/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment/moment';
import clsx from 'clsx';
import WidgetDropdown from './WidgetDropdown';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import MoneyIcon from '../../assets/svg/MoneyIcon';
import InvoiceIcon from '../../assets/svg/InvoiceIcon';
import { roundOfAndFormate } from '../../utils/Utils';
import { AppContext } from '../../context/AppContext';

function MonthInvoiceDetails({ isSelectedWidget, customerId, projectId, widgetIndex, authToken }) {
  const { getMonthlyInvoiceData } = useWidgetAPI();
  const [data, setData] = useState();
  const { widgetDropDownOptions: dropDownOptions } = useContext(AppContext);

  useEffect(() => {
    fetchWidgetData(customerId, projectId);
  }, [customerId, projectId]);

  const fetchWidgetData = async (customerId, projectId) => {
    const query = { customerId, projectId };
    const response = await getMonthlyInvoiceData(query);
    setData(response);
  };

  const renderWidgetBody = () => {
    return (
      <div className='mt-4 flex justify-start gap-2.5 overflow-x-auto break:mt-8 break:gap-8'>
        {/* <div className='flex w-[130px] flex-shrink-0 flex-col items-start justify-start rounded-xl border border-solid border-blue-400 bg-blue-200 py-3.5 px-3 break:w-[29%]'>
          <div className='w-fit rounded-lg bg-white p-3'>
            <WeightIcon />
          </div>

          <div className='mt-2.5'>
            <p className='text-[8px] break:text-xs'>Tonnage</p>
            <p className='font-semibold break:text-lg'>{roundOfAndFormate(data?.totalTonnage)}</p>
          </div>
        </div> */}
        <div className='flex w-[130px] flex-shrink-0 flex-col items-start justify-start rounded-xl border border-solid border-blue-400 bg-blue-200 py-3.5 px-3  break:w-[29%]'>
          <div className='w-fit rounded-lg bg-white p-3'>
            <MoneyIcon />
          </div>

          <div className='mt-2.5'>
            <p className='text-[8px] break:text-xs'>Total Invoice Amount</p>
            <p className='font-semibold break:text-lg'>
              {roundOfAndFormate(data?.totalAmount, true)}
            </p>
          </div>
        </div>
        <div className='flex w-[130px] flex-shrink-0 flex-col items-start justify-start rounded-xl border border-solid border-blue-400 bg-blue-200 py-3.5 px-3  break:w-[29%]'>
          <div className='w-fit rounded-lg bg-white p-3'>
            <InvoiceIcon />
          </div>

          <div className='mt-2.5'>
            <p className='text-[8px] break:text-xs'>No of Invoices</p>
            <p className='font-semibold break:text-lg'>{roundOfAndFormate(data?.noOfInvoices)}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isSelectedWidget && (
        <div className='rounded-tr-lg rounded-tl-lg border border-solid border-gray-200 bg-[#FFF5EA] py-3 px-3 text-sm font-semibold'>
          {dropDownOptions?.find((f) => f?.customerID === customerId)?.customerName}
        </div>
      )}
      <div className={clsx({ 'rounded-br-lg rounded-bl-lg': isSelectedWidget }, 'widget-wrapper')}>
        <div className='flex items-center justify-between gap-4'>
          <div className='self-start break:flex break:flex-row break:items-center break:justify-center break:gap-4'>
            <p className='text-xs font-semibold text-black break:text-sm'>Monthly Invoice Detail</p>
            <span className='rounded-xl border border-solid border-orange-700 bg-orange-200 py-1 px-2 text-[8px] italic break:text-xs'>
              {moment(data?.month).format('MMM')} {data?.year}
            </span>
          </div>
          <div className='m-0 p-0 text-[8px]'>
            <span className=''>
              {isSelectedWidget && (
                <WidgetDropdown scope='MonthInvoiceDetails' isSelected widgetIndex={widgetIndex} />
              )}
            </span>
          </div>
        </div>
        {authToken ? (
          <form action='https://prodash.natsteel.com.sg:8080/v1/auth/ump/' method='post'>
            <input type='hidden' name='token' value={authToken} />
            <input type='hidden' name='path' value={'/invoice-detail'} />
            <button className='w-full'>{renderWidgetBody()}</button>
          </form>
        ) : (
          renderWidgetBody()
        )}
      </div>
    </div>
  );
}

export default MonthInvoiceDetails;
